<div class="seg-image-selection">
    <div class="seg-image-selection__content-container">
        <selected-seg-list [segUpgradeNodes]="segUpgradeNodeList"></selected-seg-list>

        <avi-collection-data-grid
            class="seg-image-selection__data-grid"
            [config]="availableUpdatesGridConfig"
            gridTitle="{{ l10nKeys.compatibleUpdatesHeader | vtranslate }}"
            (onSelectionChange)="onImageSelectionChange($event)"
        ></avi-collection-data-grid>
    </div>
</div>

<ng-template
    #imageTypeTemplateRef
    let-row
>
    <div>
        <cds-icon
            [shape]="row.isType('IMAGE_TYPE_SYSTEM') ? 'display' : 'wrench'"
            size="18"
        ></cds-icon>
        <span> {{ row.type | enumValueLabel : 'ImageType' }}</span>
    </div>
</ng-template>
